// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDPd_9mHfAOCQswOxbEotk0PTiyNaFQZ7c",
  authDomain: "iserenify-46892.firebaseapp.com",
  databaseURL: "https://iserenify-46892-default-rtdb.firebaseio.com/",
  projectId: "iserenify-46892",
  storageBucket: "iserenify-46892.appspot.com",
  messagingSenderId: "172141235339",
  appId: "1:172141235339:web:303a20d41e9a382849988e",
  measurementId: "G-VTYND2B14S"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const provider_fb = new firebase.auth.FacebookAuthProvider();
const provider_google = new firebase.auth.GoogleAuthProvider();
const provider_apple = new firebase.auth.OAuthProvider('apple.com');
const storage = getStorage(firebaseApp);
const analytics = getAnalytics(firebaseApp);

// Initialize Realtime Database
const database = getDatabase(firebaseApp);

export {
  auth,
  provider,
  provider_fb,
  provider_google,
  provider_apple,
  storage,
  analytics,
  database,
};

export default db;
